export default __webpack_public_path__ + "static/media/Substrates-Section-Marketplace.576e2e82.jpg";